export const CONTRACTOR_1099_PREVIEW_AS = '1099';

export function contractorPortalPreviewHref(uid: string): string {
  const id = String(uid || '').trim();
  return `/contractor-timesheets?previewAs=${CONTRACTOR_1099_PREVIEW_AS}&uid=${encodeURIComponent(id)}`;
}

export function parseContractorPortalPreview(search: string): { uid: string } | null {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  if (params.get('previewAs') !== CONTRACTOR_1099_PREVIEW_AS) return null;
  const uid = String(params.get('uid') || '').trim();
  return uid ? { uid } : null;
}
